// extracted by mini-css-extract-plugin
export var box = "style-mod--box--02964";
export var extraInformationsModule = "style-mod--extra-informations-module--d79c1";
export var imageBox = "style-mod--image-box--24313";
export var modalClose = "style-mod--modal-close--93c51";
export var modalCloseContainer = "style-mod--modal-close-container--2c3f7";
export var modalCloseDesktop = "style-mod--modal-close-desktop--07640";
export var modalCloseDesktopDesktop = "style-mod--modal-close-desktop-desktop--f2be0";
export var modalCloseDesktopResponsive = "style-mod--modal-close-desktop-responsive--92c35";
export var modalCloseResponsive = "style-mod--modal-close-responsive--33c23";
export var productGroup = "style-mod--product-group--2194b";
export var question = "style-mod--question--e7468";
export var selected = "style-mod--selected--5b5d5";
export var singleBox = "style-mod--single-box--23c04";
export var textBox = "style-mod--text-box--0c014";
export var title = "style-mod--title--ab3f7";
export var variantsExtraInformationContainer = "style-mod--variants-extra-information-container--0d79b";
export var variantsInformationModal = "style-mod--variants-information-modal--cbd34";